import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-mwct-instruction-dialog',
  templateUrl: './mwct-instruction-dialog.component.html',
  styleUrls: ['./mwct-instruction-dialog.component.css']
})
export class MwctInstructionDialogComponent implements OnInit {

  constructor( public dialog: MatDialog,
               public dialogRef: MatDialogRef<MwctInstructionDialogComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
